module.exports = __webpack_public_path__ + "img/aysjjq_img.e32e7a48.png";